import { PlatformName } from '@/types';

const isServer = (): boolean => import.meta.env.SSR;

const isPlatformIs24 = (): boolean => import.meta.env.VUE_APP_PLATFORM === 'is24';
const isPlatformHg = (): boolean => import.meta.env.VUE_APP_PLATFORM === 'hg';
const getCurrentPlatform = (): PlatformName =>
  isPlatformIs24() ? PlatformName.Immoscout24 : PlatformName.Homegate;

export { getCurrentPlatform, isPlatformHg, isPlatformIs24, isServer };
